<template>
    <div>
        <navigation-bar Close/>
        <div class="main">
            <item-grid class="two-gird">
                <loyalty-card-item :dataList="dataList" :userPoint="userPoint" :key="time"
                                   :isWeb="isWeb"
                                   :loyaltyCardId="parseInt(this.loyaltyCardId)" @triggerEvent="exchangeEvent"/>
            </item-grid>
        </div>
    </div>
</template>

<script>
    import LoyaltyCardItem from '@/views/gift/components/LoyaltyCardItem.vue'
    import ItemGrid from '@/components/category/ItemGrid.vue'
    export default {
        name: "LoyaltyCardExchange",
        props: {
            isWeb: Boolean,
            dataTokenWeb: {default: ''},
        },
        components: {
            LoyaltyCardItem,
            ItemGrid,
        },
        data() {
            return {
                dataList: [],
                loyaltyCardId: 0,
                userPoint: 0,
                time: '',//為了強制重新宣染子組件用
            }
        },
        created() {
            this.loyaltyCardId = this.isWeb? parseInt(this.dataTokenWeb.id) : parseInt(this.$route.query.id);
            if (isNaN(this.loyaltyCardId)) {
                this.$router.back();
            } else {
                this.setupData();
            }
        },

        methods: {
            setupData: function () {
                //優惠卷清單
                this.$http.fetchWithAuth`GetCanExchangeLoyaltyCardList${{
                    'id': parseInt(this.loyaltyCardId),
                }}
      ${json => {
                    if (json.data !== null && json.data !== '') {
                        this.dataList = json.data;
                        this.userPoint = json.userPoint
                        this.time = new Date().getTime()
                    }
                }}`;
            },
            exchangeEvent(obj) {
                let self = this;
                let event = obj.event;
                if (event === "setupData") {
                    self.setupData();
                }
            },
        }
    }
</script>
<style lang="less" scoped src="../../less/gift.less"/>
